export const snackBarSetting = {
  maxSnack: 4,
  anchorOrigin: { horizontal: 'right', vertical: 'top' },
  autoHideDuration: 3000,
}
